import React from 'react';
import { Select } from 'antd';
import { MembershipCategory } from '../../model/members/MembershipCategory';
import { useFormatCurrency } from '../../hooks/useFormatters';

const { Option } = Select;

interface MembershipCategorySelectorProps {
    membershipCategories: MembershipCategory[];
    onChange?: (category: MembershipCategory | null) => void;
    value?: string;
    disabled?: boolean;
    // Forwarded to the underlying Select so an AntD Form.Item can associate its label with the
    // control (accessibility + testability).
    id?: string;
}

const MembershipCategorySelector: React.FC<MembershipCategorySelectorProps> = ({
    membershipCategories,
    onChange,
    value,
    disabled = false,
    id
}) => {
    const formatCurrency = useFormatCurrency();
    const handleChange = (selectedValue: string) => {
        const category = membershipCategories.find(cat => cat.name === selectedValue) || null;
        onChange?.(category);
    };

    return (
        <Select
            id={id}
            value={value}
            onChange={handleChange}
            placeholder="Select a membership category"
            disabled={disabled}
        >
            {membershipCategories.map((category) => (
                <Option key={category.name} value={category.name}>
                    {`${category.name} ${formatCurrency(category.amount)}`}
                </Option>
            ))}
        </Select>
    );
};

export default MembershipCategorySelector; 